import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faArrowDownWideShort } from "@fortawesome/free-solid-svg-icons"
import Animate, { AnimationTypes } from "../Animate/Animate"

interface CountElementsProps {
  count: number
  title: string
  animationTypes?: keyof typeof AnimationTypes
  animationDuration?: string
  boxShadow?: string
}

export const CountElements: React.FC<CountElementsProps> = ({
  count,
  title,
  animationDuration = "0.6s",
  animationTypes = AnimationTypes.fadeInTraslate,
  boxShadow,
}) => {
  return (
    <Animate type={animationTypes} duration={animationDuration}>
      <div
        className="
          w-full
          flex items-center
          gap-3
          rounded-lg
          px-4 py-1
          shadow-sm
        "
        style={{ boxShadow }}
      >
        <div className="text-red-600 text-lg">
          <FontAwesomeIcon icon={faArrowDownWideShort} />
        </div>

        <span className="text-base font-bold text-red-600">{count}</span>

        <span className="text-sm font-semibold text-slate-700">{title}</span>
      </div>
    </Animate>
  )
}
